export const DELETED_USER_LABEL = 'Deleted user'
